export default __webpack_public_path__ + "locales/events.ky.json";